import React from "react";

const VendorIntegrationIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M13 12V9C13 8.44772 13.4477 8 14 8H22C22.5523 8 23 8.44772 23 9V12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M13 25V28C13 28.5523 13.4477 29 14 29H22C22.5523 29 23 28.5523 23 28V25"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="10"
        y="12"
        width="16"
        height="13"
        rx="2"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M18 16V21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14 16V21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M22 16V21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default VendorIntegrationIcon;
